import { render, staticRenderFns } from "./video-card-slider.vue?vue&type=template&id=9d949f60&scoped=true"
import script from "./video-card-slider.vue?vue&type=script&lang=js"
export * from "./video-card-slider.vue?vue&type=script&lang=js"
import style0 from "./video-card-slider.vue?vue&type=style&index=0&id=9d949f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d949f60",
  null
  
)

export default component.exports